import { useQuery } from '@tanstack/react-query';

import { customerReviewKey } from './queryKeys';

import type { QueryParams } from '@/types/common/api.type';
import { customerReviewService } from '@/services/rest/index';

export const useCustomerReviews = (params?: QueryParams, enabled = true) =>
    useQuery({
        queryKey: customerReviewKey.list(params),
        queryFn: () => customerReviewService().index(params),
        placeholderData: previousData => previousData,
        enabled: enabled,
    });

export const useCustomerReviewById = (id: string, params?: QueryParams) => {
    return useQuery({
        queryKey: customerReviewKey.detail(id),
        queryFn: () => customerReviewService().detail(id, params),
        enabled: !!id,
    });
};
